export default "/qq_channel.56c75ff6-f9f3b8.png";